module.exports = __webpack_public_path__ + "static/img/img2.ed92fed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1920x800/img2.jpg
// module id = iW4X
// module chunks = 1